import { Outlet } from "react-router-dom"

const Billinglayout = () => {
    return(
        <div>
            <Outlet />
        </div>
    );
}

export default Billinglayout;